<template>
  <v-content>
    <slot />
  </v-content>
</template>

<script>
export default {
  data: () => ({
  })
}
</script>
